export default __webpack_public_path__ + "static/5-eacab05c49d470a742b7e466226ac1bb.png";